/**
 * Detect Australian mobile numbers in common display formats.
 * Mobile: 04XX XXX XXX (10 digits), +61 4XX XXX XXX / 614XXXXXXXX (61 + 9 digits starting with 4),
 * or national significant 4XX XXX XXX (9 digits) when shown without trunk 0.
 * Landlines use 02/03/07/08 etc., not 04.
 */
export function isAustralianMobile(value: string | null | undefined): boolean {
  if (value == null) return false;
  const digits = String(value).replace(/\D/g, '');
  if (digits.length < 9) return false;

  if (digits.startsWith('61')) {
    const nsn = digits.slice(2);
    return nsn.length === 9 && nsn.startsWith('4');
  }

  if (digits.length === 10 && digits.startsWith('04')) {
    return true;
  }

  if (digits.length === 9 && digits.startsWith('4')) {
    return true;
  }

  return false;
}
